import { workflowCalendar } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './WorkflowCalendar.css';

export function WorkflowCalendar() {
  return (
    <Section id="flujos" label="Flujos + calendario" title={workflowCalendar.title} lead={workflowCalendar.lead}>
      <div className="workflow-steps">
        {workflowCalendar.steps.map((step, i) => (
          <ScrollReveal key={step.label} delay={i * 90}>
            <div className="workflow-step">
              <div className="workflow-step__connector" aria-hidden />
              <div className="workflow-step__card glass-card">
                <span className="workflow-step__index">{i + 1}</span>
                <h3>{step.label}</h3>
                <p>{step.detail}</p>
              </div>
            </div>
          </ScrollReveal>
        ))}
      </div>
    </Section>
  );
}
